import { ReactNode } from 'react'
import BottomNav from './BottomNav'

const G = '#C89B4C'
const BD = 'rgba(244,238,225,0.14)'
const S = 'rgba(255,248,235,0.06)'

interface Props {
  children: ReactNode
  hideNav?: boolean
  title?: string
}

export default function Layout({ children, hideNav, title: _title }: Props) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header className="mobile-only" style={{
        position: 'sticky', top: 0, zIndex: 40,
        padding: '10px 20px',
        background: 'rgba(13,21,38,0.80)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: `1px solid ${BD}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: 44,
      }}>
        <span style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 11, fontWeight: 600,
          color: G, letterSpacing: '0.18em',
          textTransform: 'uppercase',
        }}>
          ANSOR NASIYA
        </span>
      </header>

      <main style={{
        flex: 1, overflowY: 'auto',
        padding: `20px 20px ${hideNav ? '24px' : '104px'}`,
      }}>
        {children}
      </main>

      {!hideNav && <BottomNav />}
    </div>
  )
}
